
import Button from "../Buttons/Button";
import { buttonWithAuthorization } from "../buttonWithAuthorization";

const FormStartButton = props => {
  const { onClick, submitLabel, disabled, isSubmitting } = props;
  const isDisabled = disabled || isSubmitting;

  return (
    <Button
      type="button"
      className="btn btn-primary btn-block-md modal-action box-shadow"
      onClick={onClick}
      label={submitLabel}
      iconClassName="icon-validate"
      iconPosition="after"
      data-loading={isSubmitting}
      disabled={isDisabled}
      data-contribution-form-start-button
    />
  );
};

export default buttonWithAuthorization(FormStartButton);
